import styled from 'styled-components'
import { BP } from 'resources/constants'
import { cmsTextBlockCss, cmsSectionHeroCss } from '../../../../components/Styled'
import { facebookButton } from 'app/sofia/resources/theme/css'

export const CmsContentWrap = styled.div`
  --txtBoxSidePad: 10vw;

  .section {
    ${cmsSectionHeroCss}

    .text-box {
      ${cmsTextBlockCss}
      padding: 20px 0;

      @media (min-width: ${BP.sm.min}) {
        padding: 30px;
      }

      @media (min-width: ${BP.md.min}) {
        display: flex;
        padding: 0 !important;

        > div {
          flex-basis: 100%;
        }
      }
    }

    &.our-story-section-1 {
      .text-box {
        @media (max-width: ${BP.md.max}) {
          padding-top: 20px;
          padding-bottom: 25px;

          @media (min-width: ${BP.sm.min}) {
            padding-top: 25px;
            padding-bottom: 35px;
          }
        }

        > div:first-child {
          @media (min-width: ${BP.md.min}) {
            padding-bottom: 2vw;
          }
        }
      }
    }

    &.our-story-section-2 {
      .container {
        @media (max-width: ${BP.md.max}) {
          background: #a0d8e5;
        }
      }

      .text-box {
        @media (max-width: ${BP.md.max}) {
          padding-top: 15px;
          padding-bottom: 20px;

          @media (min-width: ${BP.sm.min}) {
            padding-top: 25px;
            padding-bottom: 25px;
          }
        }

        > div:last-child {
          @media (min-width: ${BP.md.min}) {
            padding-left: var(--txtBoxSidePad);
            padding-bottom: 6vw;
          }
        }
      }
    }

    &.our-story-section-3 {
      @media (min-width: ${BP.md.min}) {
        z-index: 2;
      }

      .text-box {
        @media (max-width: ${BP.md.max}) {
          padding-top: 10px;
          padding-bottom: 25px;

          @media (min-width: ${BP.sm.min}) {
            padding-top: 15px;
            padding-bottom: 35px;
          }
        }

        > div:first-child {
          @media (min-width: ${BP.md.min}) {
            padding-right: var(--txtBoxSidePad);
            padding-bottom: 3vw;
          }
        }
      }
    }

    &.our-story-section-4 {
      .container {
        @media (max-width: ${BP.md.max}) {
          background: #849e67;
        }
      }

      .text-box {
        @media (max-width: ${BP.md.max}) {
          padding-top: 20px;
          padding-bottom: 35px;

          @media (min-width: ${BP.sm.min}) {
            padding-top: 20px;
            padding-bottom: 45px;
          }
        }

        > div:last-child {
          @media (min-width: ${BP.md.min}) {
            padding-left: var(--txtBoxSidePad);
            padding-bottom: 4.5vw;
          }

          .header,
          p {
            color: #fff;
          }

          p {
            margin-bottom: 15px;
          }

          .actions {
            a {
              ${facebookButton}
            }
          }
        }
      }
    }

    .flower {
      position: absolute;
      z-index: 1;
      overflow: hidden;
      display: none;

      @media (min-width: ${BP.md.min}) {
        display: block;
      }

      &.flower-1 {
        top: -200px;
        right: 0;
        width: 200px;

        @media (min-width: ${BP.lg.min}) {
          width: 250px;
          top: -250px;
        }

        img {
          width: 300px;

          @media (min-width: ${BP.lg.min}) {
            width: 400px;
          }
        }
      }

      &.flower-2 {
        left: 0;
        bottom: -160px;

        @media (min-width: ${BP.md.min}) {
          bottom: -210px;
        }

        @media (min-width: ${BP.lg.min}) {
          bottom: -250px;
        }

        img {
          width: 240px;
          margin-left: -120px;

          @media (min-width: ${BP.md.min}) {
            width: 240px;
          }

          @media (min-width: 1080px) {
            width: 270px;
          }

          @media (min-width: ${BP.lg.min}) {
            width: 310px;
          }
        }
      }

      &.flower-3 {
        width: auto;
        bottom: -110px;
        right: 0;

        @media (min-width: ${BP.lg.min}) {
          bottom: -100px;
        }

        img {
          width: 185px;
          position: relative;
          right: -30px;

          @media (min-width: ${BP.lg.min}) {
            width: 195px;
          }
        }
      }
    }
  }
`
